// removed by extract-text-webpack-plugin
module.exports = {"Card":"_2u-jfkONLjLOZ3ElUs26bY","Footer":"_2aVq0CgrW8ageHJIfw5lvc","MenuItem":"_7TdLz4tkL8XO_abajS18g","Header":"_2Cj83Iahdkqis2_MqHJ-y3","Title":"qbkIvXAinC17zFWMchq71","TableWrap":"_19XschnMQrIX4jTWrBKMFd","PaginationWrap":"_2OPGaoHH4tCJ1sTxrXknHG","ActiveLink":"_1B9jst-T2mIuFjXh2ZAioe","MainColumn":"_1KRqX-TdaIkJxZ7bQ_E86w","SideColumn":"_1Sa_xxcfZHIxh0XmZYB8UE","StackOnMobile":"OoP84wbsKEVji4hyQiOwj","container-fluid":"bVW1ATHWvDMj8Hdqvk24y"};


//////////////////
// WEBPACK FOOTER
// ./src/PagesOfUser/Metal/ContractsList/styles.module.css
// module id = 632
// module chunks = 0